// extracted by mini-css-extract-plugin
export var alternate = "_l-h";
export var black = "_l-3";
export var blue = "_l-d";
export var blueLight = "_l-c";
export var brand = "_l-7";
export var error = "_l-9";
export var gray = "_l-6";
export var grayBlue = "_l-b";
export var iconWrapper = "_l-4";
export var indigo = "_l-e";
export var orange = "_l-g";
export var pink = "_l-f";
export var primary = "_l-0";
export var purple = "_l-8";
export var success = "_l-5";
export var warning = "_l-a";
export var white = "_l-1";
export var whiteSuccess = "_l-2";